<div class="relative flex items-center max-w-auto">
  <button
    type="button"
    (click)="decrease()"
    id="decrement-button"
    data-input-counter-decrement="quantity-input"
    class="flex items-center bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-s-lg p-3 h-11"
  >
    <app-icon name="minus" class="w-3 h-3 text-gray-900 dark:text-white inline-block" />
  </button>
  <input
    type="number"
    id="quantity-input"
    data-input-counter
    aria-describedby="helper-text-explanation"
    class="bg-gray-50 border-x-0 border-gray-300 h-11 text-center text-gray-900 text-sm block w-full py-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
    placeholder="999"
    required
    [value]="value"
    (input)="onInputChange($event)"
  />
  <button
    type="button"
    (click)="increase()"
    id="increment-button"
    data-input-counter-increment="quantity-input"
    class="flex items-center bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-e-lg p-3 h-11"
  >
    <app-icon name="plus" class="w-3 h-3 text-gray-900 dark:text-white" />
  </button>
</div>
